import axios from "axios"

export const getVariousExpensesData = () => {
    return axios.get(`expenses/data`).then((res) => res).catch((error) => error);
}
